import { render, staticRenderFns } from "./CompanyCandidate.vue?vue&type=template&id=7248ff39"
import script from "./CompanyCandidate.vue?vue&type=script&lang=js"
export * from "./CompanyCandidate.vue?vue&type=script&lang=js"
import style0 from "./CompanyCandidate.vue?vue&type=style&index=0&id=7248ff39&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports